import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, shareReplay} from "rxjs";
import {environment} from "../../../environments/environment";
import {GraphicSource, TerminalGraphicDocumentDto} from "../../model/terminal-graphic.model";

/**
 * Holt die server-seitig gecachten Grafik-Dokumente (Quelle TXT/DOC) vom Rest-Service
 * (fetchTerminalGraphicDocument). Pro (RFA, Quelle) wird nur einmal geladen und geteilt,
 * sodass mehrere Image-Komponenten denselben Request nutzen.
 */
@Injectable({
  providedIn: 'root'
})
export class TerminalGraphicService {

  private readonly apiUrl = environment.terminalApiUrl;
  private readonly cache = new Map<string, Observable<TerminalGraphicDocumentDto>>();

  constructor(private http: HttpClient) {
  }

  fetch(rfaKuerzel: string, source: GraphicSource): Observable<TerminalGraphicDocumentDto> {
    const key = `${rfaKuerzel}_${source}`;
    const cached = this.cache.get(key);
    if (cached) {
      return cached;
    }
    const request$ = this.http.get<TerminalGraphicDocumentDto>(`${this.apiUrl}/graphic/${rfaKuerzel}/${source}`)
      .pipe(shareReplay({bufferSize: 1, refCount: false}));
    this.cache.set(key, request$);
    return request$;
  }
}
